<template>
	<div :class="`submit-claim ${$vuetify.breakpoint.smAndDown? 'submit-claim-sm':''}`">
		<SubmitClaimsContent
			:claimId="claimId"
			:color="color" 
			:currencies="currencies"
			:add_receipts="add_receipts"
			:update_receipts="update_receipts"
			:error_message="error_msg"
			@add-receipts="onAddReceiptsDialog($event)"
			@row-click="onRowClick($event)"
			@close="$emit('close')"
		/>
		<AddReceiptsDialog 
			v-if="receipt_list_visible" 
			:visible="receipt_list_visible" 
			:color="color" 
			:currencies="currencies"
			:exist="exist_receipt_ids"
			@error="onError($event)"
			@visible="receipt_list_visible = false"
			@add-receipts="onAddReceipts($event)"/>
		<EditReceiptDialog
			v-if="receipt_edit_visible"
			:visible="receipt_edit_visible" 
			:color="color" 
			:currencies="currencies"
			:receipt="receipt"
			:errorMessage="errorMessage"
			@close="onReceiptClose()"
			@save="onReceiptSave($event)"
		/>
	</div>
</template>
<script>
import SubmitClaimsContent from "@/views/expenses/claims/submit_claims_content";
import AddReceiptsDialog from '@/views/expenses/claims/add_receipts_dialog';
import EditReceiptDialog from '@/views/expenses/commond/edit_receipt_dialog';

export default {
	name: 'SubmitClaims',
	props: {
		claimId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			error_msg: '',
			errorMessage: '',
			loading: false,
			color: this.$attrs.color ? this.$attrs.color : '#FFB946',
			currencies: [],
			receipt: null,
			
			exist_receipt_ids: [],
			add_receipts: [],
			update_receipts: [],

			receipt_list_visible: false,
			receipt_edit_visible: false,
		}
	},
	components: {
		SubmitClaimsContent,
		AddReceiptsDialog,
		EditReceiptDialog,
	},
	created() {
		this.listCountries();
		this.update_breadcrumb();
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	methods: {
		listCountries() {
			const url = `/api/config/country`;

			return axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const currencies_by_id = new Map();

							data.forEach(country => {
								if (!country.currency) return;

								const { currency, ...country_details } = country;
								if (!currencies_by_id.has(currency.id)) {
									currencies_by_id.set(currency.id, Object.assign({}, currency, {
										countries: []
									}));
								}

								currencies_by_id.get(currency.id).countries.push(country_details);
							});

							this.currencies = Array.from(currencies_by_id.values());
						}
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onRowClick(receipt) {
			if (receipt.code) {
				const obj = receipt.code;
				if (obj.display_name.includes(obj.code)) {
					obj['display_name'] = `${obj.display_name}`;
				} else {
					obj['display_name'] = `${obj.code} - ${obj.display_name}`;
				}

				receipt['job'] = obj;
			} else {
				receipt['job'] = null;
			}
			
			this.receipt = receipt;
			this.receipt_edit_visible = true;
		},
		onError(msg) {
			if (msg.length !== 0) {
				this.receipt_list_visible = false;
				this.error_msg = msg;
			}
		},
		onAddReceiptsDialog(exist_receipt_ids) {
			this.exist_receipt_ids = exist_receipt_ids;
			this.receipt_list_visible = true
		},
		onAddReceipts(receipts) {
			this.add_receipts = receipts;
			this.receipt_list_visible = false;
		},
		onReceiptClose() {
			this.receipt_edit_visible = false;
		},
		onReceiptSave(updateObj) {
			const updateObj_tmp = updateObj;

			if (updateObj_tmp.job && updateObj_tmp.kind && updateObj_tmp.kind.overhead_mode === 1 && !updateObj_tmp.job.is_overhead) {
				this.errorMessage = "You can't use an overhead kind on a client job";
				return ;
			} else if (updateObj_tmp.job && updateObj_tmp.kind && updateObj_tmp.kind.overhead_mode === 0 && updateObj_tmp.kind.show_over === 0 && updateObj_tmp.job.is_overhead) {
				this.errorMessage = "You can't use a client kind on an overhead job";
				return ;
			}; 

			this.update_receipts = [updateObj_tmp];

			if (this.receipt_edit_visible) {
				this.receipt_edit_visible = false;
			}		
		},
		update_breadcrumb() {
			// add this page to our breadcrumbs
			this.$store.commit("push_breadcrumb", {
				exact: true,
				text: `Claim ${this.$route.params.id}`,
				to: `/expenses/claims/${this.$route.params.id}`
			});
		},
	}
}
</script>